export default __webpack_public_path__ + "static/media/btn-delete.89bc4bb1.svg";